import type { GeneratedFile } from "../types";
import { downloadResource } from "./resource-cache";

// Prepare the bytes before the save gesture. Awaiting a fetch inside navigator.share's
// click handler can lose Safari's transient user activation.
export async function prepareGeneratedFile(file: GeneratedFile): Promise<File> {
  const dataUrl = await downloadResource(file.downloadUrl);
  const comma = dataUrl.indexOf(",");
  const mimeType = dataUrl.slice(5, dataUrl.indexOf(";"));
  const bytes = Uint8Array.from(atob(dataUrl.slice(comma + 1)), (character) => character.charCodeAt(0));
  return new File([bytes], file.fileName, { type: mimeType });
}

export function canShareFile(file: File): boolean {
  try { return typeof navigator.share === "function" && navigator.canShare?.({ files: [file] }) === true; }
  catch { return false; }
}

export function releaseDownloadUrl(url: string): void {
  // A download or a new Safari tab can still be consuming this URL when the sheet closes.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
